import moment from 'moment';

export const getDobDate = profile => (profile.dateOfBirth ? moment(profile.dateOfBirth).format('D') : '');
export const getDobMonth = profile => (profile.dateOfBirth ? moment(profile.dateOfBirth).format('M') : '');
export const getDobYear = profile => (profile.dateOfBirth ? moment(profile.dateOfBirth).format('YYYY') : '');

export const getFormName = profileForm => profileForm && profileForm.values && profileForm.values.name;
